import React, { useEffect, useContext, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';

import { getInvestors } from '../../../services/investorsService';

import { filterBy } from '@progress/kendo-data-query';

import FilterCtx from '../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IInvestor } from '../../../services/types/IInvestor';
import { IInvestorsFilter } from '../../types/IInvestorsFilter';

import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Switch } from '@progress/kendo-react-inputs';

import '../../multiselect/multiselect.scss';
import '../filters.scss';

const InvestorsFilter: React.FC<IInvestorsFilter> = ({ table, toggleOn }) => {
  const [value, setValue] = useState<any[]>([]);
  const [filterChoice, setFilterChoice] = useState<IInvestor[]>([]);
  const [cashChoice, setCashChoice] = useState<IInvestor[]>([]);
  const [checked, setChecked] = useState(false);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  const handleInvestorsToggleChange = (e): void => {
    setChecked(e.value);
    filterCtx.setInvestorsToggle(e.value);
    filterCtx.setInvestors([]);
    setValue([]);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'objectName']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'objectName' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'objectName');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'objectName');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handleInvestorChange = (e): void => {
    setValue(e.target.value);
  };

  const handleInvestorFilterChange = (event: any): void => {
    setFilterChoice(filterBy(cashChoice.slice(), event.filter));
  };

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('objectName') + 1 > 0);
    getInvestors()
      .then((res: IInvestor[]) => {
        setFilterChoice(res);
        setCashChoice(res);
      })
      .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    if (table === 'documents' && filterCtx.investors) {
      setValue(filterCtx.investors);
    } else {
      setValue(filterCtx.investorsActivity);
    }
  }, [impersonation]);

  useEffect(() => {
    if (table === 'documents') {
      filterCtx.setInvestors(value);
    } else {
      filterCtx.setInvestorsActivity(value);
    }
  }, [value]);

  return (
    <div className='investors-filter-wrapper pointer'>
      <MultiSelect
        className={toggleOn && checked ? 'multiselect-padding-left custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : toggleOn && !checked ? 'custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : 'custom-dropdown-style filters-dropdown'}
        data={filterChoice}
        textField='name'
        dataItemKey='objectId'
        value={value}
        placeholder={t('FILTERS.INVESTORS')}
        filterable={true}
        disabled={toggleOn && checked}
        onChange={handleInvestorChange}
        onFilterChange={handleInvestorFilterChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('objectName') + 1 > 0 && (
        <div className='switch-number-container'>
          <span>{filterCtx.slicerChoices.indexOf('objectName') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className='switch-container'>
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handleInvestorsToggleChange} />
        </div>
      )}
    </div>
  );
};

export default InvestorsFilter;
